module.exports = __webpack_public_path__ + "img/DiHS_Video_Icon_Sr_Multiview1.deecb51f.jpg";